<template>
  <div class="content">
    <van-nav-bar title="订单结算" @click-left="onClickLeft">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/navBack.png')" alt="" />
      </template>
      <!--      <template #right>-->
      <!--        <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../../assets/car_icon.png" alt="">-->
      <!--      </template>-->
    </van-nav-bar>
    <div class="block-address">
      <div @click="goToAddress" class="address-picker justify-align">
        <div>
          <div class="" v-if="address">
            <div class="address-name left-justifying">
              <div class="" style="max-width: 30.66667vw">{{address.name}}</div>
              <div class="address-phone">{{address.tel}}</div>
            </div>
            <div class="address" v-if="addressType==1">收货地址：{{address.address}}</div>
            <div class="address" v-else>收货地址：{{address.area}} {{address.address}}</div>
          </div>
          <div class="flex-grow-1" v-else>
            <div style="color:#ff4544">请选择收货地址</div>
          </div>
        </div>
        <div class="flex-grow-0 flex-y-center">
          <van-icon name="arrow" color="#ccc" />
        </div>
      </div>
    </div>
    <!--    商品详情页进来-->
    <div class="mch-item">
      <div class="mch-header left-justifying"><img class="shop-icon" :src="require('../../assets/'+appTheme+'/shop_icon.png')" alt="" /> {{goodsInfo.shop.name}}</div>
      <div class="cart-list">
        <div class="cart-item border-bottom">
          <div class="left-justifying" style="align-items: self-start;position: relative">
            <div class="flex-grow-0">
              <img class="goods-pic" :src="goodsInfo.image" />
            </div>
            <div class="goods-content">
              <div class="flex-grow-1">
                <div class="goods-name">
                  <!--                    <span>￥</span>-->
                  {{goodsInfo.name}}</div>
                <!--                <div class="attr-list">-->
                <!--                  <div class="attr-item" v-for="(attr,j) in goods.attr_list" :key="j">-->
                <!--                    {{attr.attr_group_name}}:{{attr.attr_name}}-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
              <div class="" style="text-align: right;position: absolute;right: 0;bottom: 1.33333vw;">
                <div class="flex-grow-0 price" v-if="payTypeId !='' && goodsInfo.onepay_goods">￥{{goodsInfo.onepay_goods.price}}</div>
                <div class="flex-grow-0 price" v-else>￥{{goodsInfo.price}}</div>
                <div class="num">×{{submitNumber}}</div>
              </div>
            </div>
          </div>
          <!--            <div class="level-price" v-if="goods.is_level==1">会员折扣价：￥{{goods.level_price}}</div>-->
        </div>
      </div>
    </div>
    <div class="ticket-box">
      <!-- 优惠券单元格 -->
      <div class="justify-align discount-box freight-box" v-if="couponList.length>0" @click="showList = true">
        优惠券
        <div class="left-justifying">
          <span style="color: #F23926">{{bonus_des}}</span>
          <img style="margin-left: 2.66667vw;" :src="require('../../assets/'+appTheme+'/order_right.png')" alt="" />
        </div>
      </div>
      <!-- 优惠券列表 -->
      <van-popup
        v-model="showList"
        round
        position="bottom"
        style="padding-top: 0.53333vw;"
      >
        <div class="ticket-list">
          <div class="ticket-title">优惠券</div>
          <div class="discount-coupon-box">
            <van-radio-group v-model="radio">
              <div class="discount-coupon-item justify-align" v-for="(item,index) in couponList" :key="index">
                <div>
                  <div class="coupon-item-title" style="color: #000;">{{item.title}}</div>
                  <div class="price-hint" v-if="item.type=='subsidy'">
                    <div class="left-justifying" style="color: #666;">代金券<div style="color: #fa2424;"><span>￥</span>{{item.preferential_amount}}</div></div>
                    <div style="color: #666;" class="" v-if="item.sufficient_amount !='0.00'"><span>满</span> {{item.sufficient_amount}} <span>可用</span></div>
                  </div>
                  <div class="discount-hint" v-if="item.type=='discount'">
                    <span style="color: #fa2424;">{{item.discount |filterDiscount}}折</span>
                  </div>
                </div>

                <van-radio :name="index" checked-color="#F23926"></van-radio>
              </div>
            </van-radio-group>
          </div>
          <div class="discount-coupon-btn" @click="discountsPriceClick">确定</div>
        </div>
      </van-popup>
      <div class="justify-align freight-box">
        消费总额 <span style="font-size: 3.2vw;color: #282828;">￥{{totalMoney}}</span>
      </div>
      <div class="justify-align freight-box">
        优惠金额 <span style="color: #F23926;font-size: 3.2vw;">-￥{{discountsPrice}}</span>
      </div>
      <div class="freight-box" style="text-align: right;">
        合计金额： <span style="color: #F23926;font-size: 3.73333vw;">￥{{sumPrice}}</span>
      </div>
    </div>

    <div class="" style="margin-top: 2.66667vw">
      <van-field
        v-model="message"
        rows="1"
        autosize
        label="订单备注"
        maxlength="64"
        type="textarea"
        placeholder="请填写订单备注"
      />
    </div>
    <div @click="onSubmit" class="submitBtn">￥{{sumPrice}}元确定下单</div>
  </div>
</template>

<script>
import { orderPay,addressList,checkoutGoodsDes } from '@/api/goods'
import coupon from "@/components/coupon";
import cal from '@/utils/calculation';
export default {
  name: 'orderPay',
  data() {
    return {
      appTheme:this.$store.state.appTheme,
      totalMoney:0, // 消费总金额
      discountsPrice: 0, /// 优惠券金额
      sumPrice: '', // 合计金额
      couponList1: [{name:'省1：组合优惠  ￥1', price: 1,type:0},{name:'省0.1：组合优惠  ￥0.10', price: 0.1,type:1}],
      couponList:[],
      radio: -1,
      chosenCoupon: -1,
      showList:false,
      address: '',
      addressType: 0, // 0请求地址 1自己选择的地址
      message: '',
      submitNumber: '', // 非等于空 商品详情页进来  // 为空购物车进来
      goodsInfo: '',
      mch_list: [
        {
          name: 'IT快车',
          goods_list: [
            {
              goods_pic: require('@/assets/zhongshanjingpin.png'),
              goods_name: '厨邦酱油100ml关注【全球灯云】公众号厨邦酱油100ml关注',
              num:1,
              price: 88.22,
              level_price: 69.22,
              give:2,
              attr_list: [
                {
                  attr_group_name: '规格', attr_name: '默认'
                }
              ]
            }
          ]
        }
      ],
      payTypeId:'', // 1元秒杀要传值的
      is_onepay:0, // 一元购商品，0否 1是
      bonus_des:'',
      bonus_id: null,
      bonus_info: ''
    }
  },
  // beforeRouteLeave(to,from,next){
  //   console.log(to)
  //   if (to.name == 'addressList'){
  //     if (!from.meta.keepAlive){
  //       from.meta.keepAlive = false;
  //     }
  //     next()
  //   }else {
  //     from.meta.keepAlive = false
  //     to.meta.keepAlive = false;
  //     this.$destroy();
  //     next();
  //   }
  // },
  filters: {
    getnum(num){
      num = String(num)
      return num.substring(0,num.indexOf(".")+3);
    },
    filterDiscount: function (value){
      var discount = value/10
      return discount
    }
  },
  computed:{
    getAddressInfo(){
      // 在vuex中获取数据
      // 通过getters获取数据
      console.log(this.$store.state.addressInfo)
      // var info = JSON.parse(this.$store.getters.getAddressInfo)
      return this.$store.state.addressInfo
    },
  },
  activated(){   //在activated生命周期内，从sessionStorage中读取高度值并设置到dom
    // var goods = this.$route.query.goods
    // this.goodsInfo = goods
    // this.submitNumber = this.$route.query.num
    // console.log('goods',this.goodsInfo)
    // this.totalMoney = (parseFloat(this.goodsInfo.price)*parseFloat(this.submitNumber)).toFixed(2)
    // this.sumPrice = this.totalMoney
    // console.log('进入这里')
    // this.address = this.$store.state.addressInfo
    // console.log(this.$store.state.addressInfo)
  },
  created() {

    console.log('goods',this.$route.query.goods)
    // console.log('goods',this.$route.query.one)

    if (this.$route.query.one != undefined){ // 一元购进来
        this.payTypeId = this.$route.query.one
      // console.log('goods',this.$route.query.one)
      this.is_onepay = 1 // 一元购商品，0否 1是
    } else {
      this.payTypeId = ''
      this.is_onepay = 0 // 一元购商品，0否 1是
    }
    if (typeof this.$route.query.goods=='object'){ // 正常进来
      // console.log('222222')
      let goods = this.$route.query.goods
      this.goodsInfo = goods
        // console.log('this.goodsInfo',this.goodsInfo)
      this.submitNumber = this.$route.query.num
      if (this.$route.query.one != undefined && this.goodsInfo.onepay_goods) { // 一元购进来

        this.is_onepay = 1 // 一元购商品，0否 1是


      }else { // 正常商品进来


        this.is_onepay = 0 // 一元购商品，0否 1是
      }


      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload",()=>{
        var goodsInfo = JSON.stringify(this.goodsInfo)
        this.$store.commit("setGoodsInfo", goodsInfo);
        this.$store.commit("setSubmitNumber",this.submitNumber)
        if (this.bonus_des != ''){ // 处理选着地址有券信息不见
          const bonus = JSON.stringify(this.bonus_info)
          this.$store.commit("setBonusInfo",bonus)
        }
        if (this.payTypeId !=''){ // 一元购
          this.$store.commit("setPayTypeId",this.payTypeId)
        }
      })
    }else {
      console.log('地址进来')
     // 后退进来赋值
      var goods = JSON.parse(this.$store.state.goodsInfo)
      // console.log(goods)
      // console.log('goods',this.$store.state.goodsInfo)
      this.goodsInfo = goods
      this.submitNumber = this.$store.state.submitNumber
      // console.log(this.payTypeId)
      // 后退进来赋值end
      var oneId = this.$store.state.payTypeId
      if (oneId !=''){
        this.payTypeId = this.$store.state.payTypeId
        this.is_onepay = 1 // 一元购商品，0否 1是
      }
      if (oneId != '' && this.goodsInfo.onepay_goods) { // 一元购进来

        this.is_onepay = 1 // 一元购商品，0否 1是
      }else { // 正常商品进来

        this.is_onepay = 0 // 一元购商品，0否 1是
      }

    }



    const info = this.$store.state.addressInfo
    // console.log(info)
    if (info != false){
      this.address = this.$store.state.addressInfo
      console.log(this.address)
    }else{
      // this.getAddressList()
    }
    this.checkOrderDes()
    // console.log(info)
  },
  methods: {
    checkOrderDes(){
      var that = this
      let id= that.goodsInfo.id
      let data = ''
      if (this.is_onepay==1){ // 一元购
        data= {
          // is_onepay: this.is_onepay, // 一元购商品，0否 1是
          number:this.submitNumber,
          id:that.goodsInfo.id,
          one_pay_goods_id:this.payTypeId
        }
      } else { // 普通
        data= {
          number:this.submitNumber,
          selected_bonus_id: this.bonus_id !=''? this.bonus_id:''
        }
      }
      checkoutGoodsDes(id,data).then(res => {
        if(res.code == 200)
        {
          this.couponList = res.data.bonus
          let resData= res.data
          this.totalMoney = resData.total // 总金额
          this.sumPrice = resData.payment_amount
          this.discountsPrice = resData.preferential_total
          var currIndex = this.radio
          let bonusItem = ''
          this.couponList.forEach(function(value,index){
            if (value.selected == true){ // 折扣券跟当前选中的id
              // this.radio = index
              currIndex = index
              // console.log('value',value)
              bonusItem = value

            }
          })
          this.radio = currIndex // 赋值选中 id
          this.bonus_id = bonusItem.id
          this.bonus_des = bonusItem.title
          this.bonus_info = bonusItem
          const info = this.$store.state.addressInfo
          // console.log(info)
          if (info != false){ // // 0请求地址 1自己选择的地址
            this.addressType = 1
            this.address = this.$store.state.addressInfo
            console.log(this.address)
          }else{ // 获取返回的
            this.address = res.data.address
          }
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    getAddressList(){
      var that = this
      addressList().then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data.data)
          var arr = res.data.data
          if (arr.length == 0){
            that.address = ''
          } else {
            that.address= arr[0]
            var item = arr[0]
            this.$store.commit("setAddressInfo",item);
          }
          // var arrSec = JSON.parse(JSON.stringify(arr).replace(/phone/g,'tel').replace(/is_default/g,'isDefault'))
          // this.list = arrSec
        }
        else
        {
          this.$toast(res.message)
          this.$router.push('/');
        }
      })
    },
    discountsPriceClick(){
      this.showList = false
      if (this.radio != -1){
        console.log('要计算',this.couponList[this.radio])
        this.bonus_id = this.couponList[this.radio].id
        this.bonus_des = this.couponList[this.radio].title
        this.bonus_info = this.couponList[this.radio]
        this.checkOrderDes()
      } else {
        console.log('bu要计算')
      }
      // this.couponList[this.radio]
      console.log( this.couponList[this.radio])
      // console.log(this.radio)
    },
    getnum(num){
      num = String(num)
      return num.substring(0,num.indexOf(".")+3);
    },
    onClickLeft() {
      // 清掉存储的goodsInfo
      this.$store.commit("setGoodsInfo",'');
      this.$store.commit("setSubmitNumber",'')
      this.$store.commit("setPayTypeId",'')// 一元购
      this.$store.commit("setPayInfo",'')// 支付信息
      this.$router.go(-1);

    },
    onClickRight() {
      this.$router.push({path:'/cart'})
      this.$store.commit("setGoodsInfo",'');
      this.$store.commit("setSubmitNumber",'')
      this.$store.commit("setPayTypeId",'')// 一元购
      this.$store.commit("setPayInfo",'')// 支付信息
    },
    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
    },
    goToAddress(){
      // const addDate = JSON.stringify(item)
      var goodsInfo = JSON.stringify(this.goodsInfo)
      this.$store.commit("setGoodsInfo", goodsInfo);
      if (this.bonus_des != ''){ // 处理选着地址有券信息不见
        const bonus = JSON.stringify(this.bonus_info)
        this.$store.commit("setBonusInfo",bonus)
      }
      this.$store.commit("setSubmitNumber",this.submitNumber)
      if (this.payTypeId !=''){ // 一元购
        this.$store.commit("setPayTypeId",this.payTypeId)
      }
      this.$router.push({path:'/addressList',query: {type:1}})
    },
    onSubmit(){
      var that = this
      var address = that.address
      if (address==''){
        this.$toast('请选择地址')
        return false
      }
      var data = ''
      if (this.payTypeId !=''){ // 1元
        data = {
          number: this.submitNumber,
          address_id: address.id,
          goods_id:this.goodsInfo.id,
          message: this.message,
          onepay_item_id: this.payTypeId,
          bonus_id:this.bonus_id
        }
      } else {
        data = {
          number: this.submitNumber,
          address_id: address.id,
          goods_id:this.goodsInfo.id,
          message: this.message,
          bonus_id:this.bonus_id
        }
      }

      orderPay(data).then(res => {
        if(res.code == 200)
        {
          // this.$toast(res.message)
          // console.log(res.data)
          this.$store.commit("setBonusInfo",'')
          var data = JSON.stringify(res.data)
          // this.$router.push('/paySucceed')
          // 为了处理后退不下单开始
          var goodInfo = JSON.stringify(this.goodsInfo)
          // console.log(goodInfo)

          if (this.payTypeId !=''){ // 一元购项目id
            this.$store.commit("setPayTypeId",this.payTypeId)
          }
          // 为了处理后退不下单end
          this.$router.push({path:'/submitOrder',query: {id:this.goodsInfo.id,pay:data,goodInfo: goodInfo,submitNumber:this.submitNumber}})
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-list{
  padding-bottom: 30px;
  .ticket-title{
    font-size: 30px;padding: 20px 20px;font-weight: 400;
    color: #282828;
  }
  .discount-coupon-box{
    padding: 0 20px;margin-top: 20px;
    .discount-coupon-item{

      font-size: 24px;
      padding: 15px 10px;
      border: 1px solid #F5F5F5;margin-bottom: 10px;
      .coupon-item-title{
        font-size: 28px;padding-bottom: 5px;
      }
    }
    height: 60%;margin-bottom: 20px;overflow-y: auto;
  }
  .discount-coupon-btn{
    width: 577px;
    font-weight: bold;font-size: 32px;padding: 18px 0;
    background: #FDD80D;
    border-radius: 41px;margin: 0 auto 20px;text-align: center;
  }
}
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.submitBtn{
  width: 570px;
  text-align: center;margin: 211px auto 20px;padding: 20px 0;
  background: #FDD80D;
  border-radius: 45px;font-size: 38px;font-weight: bold;
}
.van-cell::after {
  border-bottom: none;
}
.ticket-box{
  color: #282828;font-size: 24px;
  .discount-box{
    img{
      width: 14px;height: auto;display: block;
    }
  }
}
.mt20{
  margin-top: 20px;
}
.freight-box{
  padding: 24px 32px;background: #ffffff;font-size: 28px;
}
.block-address{
  background: #ffffff;padding: 20px;text-align: left;font-size: 28px;
  .address-name{
    margin-bottom: 20px;
    font-weight: bold;
    color: #000000;font-size: 30px;
    .address-phone{
      margin-left: 30px;
    }
  }
  .address{
    white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 24px;color: #000000;
  }
}
.level-price{
  color:#ff4544;text-align:right;margin-bottom:22px;
}
.pay-way{
  background: #fff;padding: 24px 24px;margin-bottom: 20px;margin-top: 10px;
  .pay-txt{
    font-size: 26px;

  }
}
.mch-item{
  margin-top: 20px;background: #ffffff;
  .mch-header{
    padding: 20px 24px;background: #ffffff;text-align: left;
    .shop-icon{
      width: 24px;height: auto;display: inline-block;margin-right: 15px;
    }
  }
  .goods-content{
    width: 75%;
    .flex-grow-1{
      text-align: left;
    }
  }
}
.cart-item {
  background: #fff;
  padding-bottom: 20px;
  margin: 32px 24px 0 24px;border-bottom: 2px solid #E5E5E5;
}

.cart-item .goods-pic {
  width: 164px;
  height: 164px;
  border-radius: 15px;
  margin-right: 20px;
}

.cart-item .goods-name {
  font-weight: bold;
  color: #636363;font-size: 28px;
  margin-bottom: 10px;
 span{
   display: inline-block;
    padding: 0 10px;
   background: #F23926;
   border-radius: 5px;font-size: 18px;color: #FFFFFF;font-weight: bold;text-align: center;
 }
}

.cart-item .attr-list,.cart-item .num {
  font-size: 20px;
  color: #A4A4A4;text-align: right;
}

.cart-item .attr-list .attr-item {
  display: inline-block;
  margin-right: 36px;
}

.cart-item .attr-list .attr-item:last-child {
  margin-right: 0;
}

.cart-item .price {
  color: #F23926;font-size: 28px;font-weight: 500;
}

</style>
